import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { CommonServiceApiTags } from '../api-tags';
import { useChatUnreadStore } from './service-store/service-store';
export var useChatUnreadActions = function () {
    var queryClient = useQueryClient();
    var incrementUnreadMessagesCount = useChatUnreadStore(function (state) { return state.incrementUnreadMessagesCount; });
    var refreshUnreadMessagesCount = useCallback(function () {
        var _a;
        var queryKey = [CommonServiceApiTags.ChatUnread];
        var unreadMessagesCount = useChatUnreadStore.getState().content.unreadMessagesCount;
        var isFetching = ((_a = queryClient.getQueryState(queryKey)) === null || _a === void 0 ? void 0 : _a.fetchStatus) === 'fetching';
        if (!unreadMessagesCount || isFetching)
            return Promise.resolve();
        return queryClient.invalidateQueries({ queryKey: queryKey });
    }, [queryClient]);
    return { incrementUnreadMessagesCount: incrementUnreadMessagesCount, refreshUnreadMessagesCount: refreshUnreadMessagesCount };
};
